'use client';
import { useCategoryTree } from './useCategoryTree';
import { useMemo } from 'react';
import { convertTreeToFlatDict } from '@/utils/SEOPathModule/utils';
export const useGetCategoryIdDict = () => {
  const query = useCategoryTree();
  const data = useMemo(() => convertTreeToFlatDict(query.data ?? []), [query.data]);
  return { data, isLoading: query.isLoading };
};
